/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Blank_Lines_LabelInputs */



/**
* | output |
* | --- |
* | "Blank Lines" |
*
* @param {Style_Guide_Manager_Blank_Lines_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_blank_lines_label = /** @type {((inputs?: Style_Guide_Manager_Blank_Lines_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Blank_Lines_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lignes vides")
	if (locale === "de") return /** @type {LocalizedString} */ ("Leere Zeilen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Righe vuote")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пустые строки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Líneas en blanco")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("空白行")
	if (locale === "ja") return /** @type {LocalizedString} */ ("空白行")
	if (locale === "hi") return /** @type {LocalizedString} */ ("रिक्त पंक्तियाँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Linhas em branco")
	return /** @type {LocalizedString} */ ("Blank Lines")
});